"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Modal_1 = __importDefault(require("shared/components/Modal/Modal"));
var Modal = (0, styles_1.styled)(Modal_1.default)(function () { return ({
    '.MuiBackdrop-root': {
        background: 'rgba(10, 10, 10, 0.5)',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.02), 0px 4px 6px rgba(0, 0, 0, 0.06), 0px 7px 16px rgba(15, 15, 15, 0.08)',
    },
}); });
exports.default = Modal;
